import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { Hours } from 'src/app/services/analyse/analyse.types';
import { formatYYYYMMDDHHNumberToDate } from 'src/app/utils/date-utils';

@Component({
  selector: 'app-daymax-three',
  standalone: true,
  imports: [CommonModule, IonicModule],
  template: `
    <ion-row>
      <ion-col class="px-2 py-3">
        @if (!errorAnalyse && highThree.length > 0) {
        <p class="m-0">
          <strong>⚡️ Dine høyeste døgnmakser</strong>
        </p>
        <div class="flex items-center mb-3 ml-5 gap-4">
          <p class="m-0">Snitt:</p>
          <p class="m-0">{{ avgDayMax.toFixed(2).replace('.', ',') }} kWh</p>
        </div>
        <div class="flex items-center justify-between text-center">
          @for (value of highThree; track $index) {
          <div class="flex flex-col items-center px-3 pb-1">
            <p class="m-0">
              {{
                formatYYYYMMDDHHNumberToDate(value.period - 1).toLocaleDateString(
                  'nb-NO',
                  {
                    day: 'numeric',
                    month: 'short',
                  }
                )
              }}
            </p>
            <p class="m-0">
              kl.
              {{
                formatYYYYMMDDHHNumberToDate(value.period - 1).toLocaleTimeString(
                  'nb-NO',
                  {
                    hour: 'numeric',
                    minute: 'numeric',
                  }
                )
              }}
            </p>
            <p class="m-0">
              <strong>{{ value.kwh.toFixed(2).replace('.', ',') }} kWh</strong>
            </p>
          </div>
          }
        </div>
        } @else {
        <p class="bg-[--warning-40] p-4 rounded-lg m-0">
          Det skjedde dessverre en feil når vi prøvde å hente døgnmakser. Prøv
          igjen senere.
        </p>
        }
      </ion-col>
    </ion-row>
  `
})
export class DayMaxThreeComponent {
  @Input() errorAnalyse: boolean;
  @Input() currentHighThreeDayMax: Hours[];

  highThree: Hours[] | undefined;
  avgDayMax: number;
  formatYYYYMMDDHHNumberToDate = formatYYYYMMDDHHNumberToDate;

  constructor() {}

  ngOnChanges() {
    this.highThree = [...this.currentHighThreeDayMax].sort((a, b) => {
      return a.period - b.period;
    });
    this.avgDayMax =
      this.highThree.reduce((acc, curr) => acc + curr.kwh, 0) /
      this.highThree.length;
  }
}
